import DashboardLayout from '../../layouts/DashboardLayout';
import ComingSoon from '../ComingSoon';

const ComingSoonGuard = ({
  children,
  isComingSoon,
  title,
}: {
  children: React.ReactNode;
  isComingSoon?: boolean;
  title?: string;
}) => {
  return !isComingSoon ? (
    children
  ) : (
    <DashboardLayout title={title || 'Coming Soon'}>
      <ComingSoon />
    </DashboardLayout>
  );
};

export default ComingSoonGuard;
